var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"flex"}},[_c(_setup.VIcon,{staticStyle:{"height":"23px","width":"23px","min-height":"23px","min-width":"23px"},attrs:{"color":_vm.iconColor}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('p',{staticStyle:{"margin-left":"5px !important"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }